import {Pipe, PipeTransform} from '@angular/core';
import {GeneralExpenseSimpleDto} from '../../Models/Documents-review/general-expense-simple';

@Pipe({
  name: 'generalExpenses',
  standalone: false
})
export class GeneralExpensesPipe implements PipeTransform {

  transform(items: GeneralExpenseSimpleDto[], filter: { review?: boolean }): GeneralExpenseSimpleDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (filter.review) {
      items = items.filter((item) => item.pendiente_ocr || item.error_ocr);
    }

    return items;

  }

}
